import { createRouter, createWebHistory } from 'vue-router';

import WelcomePage from '@/page/WelcomePage.vue';
import ChatPage from '@/page/ChatPage.vue';
import DecorationPage from '@/page/DecorationPage.vue';

// 根据环境变量判断是否处于维护模式
// 在 .env.production 中通过 VUE_APP_MAINTENANCE 控制，值为 'true' / 'false'
const isMaintenance = false;
const routes = isMaintenance
  ? [
      {
        path: '/',
        name: 'Maintenance',
        component: DecorationPage,
      },
      {
        // 任意其他路径统一跳转到维护页
        path: '/:pathMatch(.*)*',
        redirect: '/',
      },
    ]
  : [
      {
        path: '/',
        name: 'Welcome',
        component: WelcomePage,
      },
      {
        path: '/chat',
        name: 'Chat',
        component: ChatPage,
      },
      {
        path: '/:pathMatch(.*)*',
        redirect: '/',
      },
    ];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;

